import styled from 'styled-components';

export const TextAreaContainer = styled.div`
    position: relative;
    width: 100%;
    display: flex;
    flex-direction: column;
`;

export const TextCounter = styled.div`
    font-size: 12px;
    color: #666666;
    margin-top: 4px;
    text-align: right;
    align-self: flex-end;
`;
